import {Component as $2grrN$Component} from "react";
import {Slider as $2grrN$Slider} from "@blueprintjs/core";
import $2grrN$macrostrathyper from "@macrostrat/hyper";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;


var $8ca3aedf5cf7ac4d$exports = {};

$8ca3aedf5cf7ac4d$exports = (parcelRequire("daZiC")).getBundleURL('2grrN') + "picker-base.c97eca5e.js";



const $e50f9f3dfdb4a354$var$surfaceTypes = [
    {
        value: "mfs",
        label: "Maximum flooding surface"
    },
    {
        value: "sb",
        label: "Sequence boundary"
    }
];
function $e50f9f3dfdb4a354$export$877eb4bd7a9ed8de(props) {
    const { interval: interval, onChange: onChange } = props;
    //if not interval.surface_type?
    //  return h 'p', 'Please set an surface type to access orders'
    let val = interval.surface_order;
    if (val == null) val = 5;
    return (0, $2grrN$macrostrathyper)((0, $2grrN$Slider), {
        min: 0,
        max: 5,
        disabled: interval.surface_type == null,
        stepSize: 1,
        showTrackFill: false,
        value: val,
        onChange: (surface_order)=>{
            if (interval.surface_type == null) return;
            return onChange({
                surface_order: surface_order
            });
        }
    });
}
function $e50f9f3dfdb4a354$export$8c0a904f1bf224ec(props) {
    return (0, $2grrN$macrostrathyper)((0, $8ca3aedf5cf7ac4d$exports.PickerControl), {
        vertical: false,
        isNullable: true,
        ...props
    });
}
class $e50f9f3dfdb4a354$export$9e0d3e5b8bc67825 extends (0, $2grrN$Component) {
    render() {
        const { interval: interval, onUpdate: onUpdate } = this.props;
        const states = [
            {
                label: "Abrupt",
                value: true
            },
            {
                label: "Diffuse",
                value: false
            }
        ];
        return (0, $2grrN$macrostrathyper)($e50f9f3dfdb4a354$export$8c0a904f1bf224ec, {
            states: states,
            activeState: interval.definite_boundary,
            onUpdate: onUpdate
        });
    }
}


//# sourceMappingURL=controls.83c43917.js.map
